// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_CarregaPlanosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for carrega_planos endpoint
 *
 * Returns array of plano (budget template) records with metadata.
 * Each plano includes: id, franquia_id, status, nome, created_at, updated_at,
 * total_itens, fixas_count, variaveis_count, plus injected `franquia` name.
 *
 * @see Planoscontas_CarregaPlanoRow
 */
import type { Planoscontas_CarregaPlanoRow } from './Planoscontas_CarregaPlanoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planoscontas_CarregaPlanosResponseDados {
planos: Planoscontas_CarregaPlanoRow[]
}

export type Planoscontas_CarregaPlanosResponse = ApiResponse<Planoscontas_CarregaPlanosResponseDados>;

registerResponseContract('Planoscontas_CarregaPlanosResponse', {
  planos: {
    type: 'array',
    required: true,
    items: {
      id:              { type: 'number',  required: false },
      franquia_id:     { type: 'number',  required: false },
      status:          { type: 'string',  required: false },
      nome:            { type: 'string',  required: false },
      created_at:      { type: 'string',  required: false },
      updated_at:      { type: 'string',  required: false },
      total_itens:     { type: 'string',  required: false },
      fixas_count:     { type: 'string',  required: false },
      variaveis_count: { type: 'string',  required: false },
      franquia:        { type: 'string',  required: false },
    },
  },
})
